module.exports = __webpack_public_path__ + "img/开场·屏幕里的公主 v2.808895b7.png";